<template>
  <div class="container">
    <div class="form-container">
      <el-form label-width="150px" :model="form" ref="form" :rules="rules">
        <el-form-item label="油站名称">
          {{ userInfo.gasName }}
        </el-form-item>

        <el-form-item label="是否使用营销基金" required v-if="isHasFundsAccount">
          <el-radio-group v-model="form.isFundUsed">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <span class="fund-tips">
            <span>* 营销基金冻结余额：{{ frostBalance }}元</span>
            <el-popover
              placement="top-start"
              width="280"
              trigger="hover"
              content="营销基金冻结金额可用于活动让利的扣除，若冻结金额不足，可联系业务经理充值。当冻结金额不足时，活动的让利金额将从当日的结算账单中扣除。">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </span>
        </el-form-item>

        <el-form-item label="商家返券" required v-if="activeType === 9">
          <el-radio-group v-model="form.isRebate">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="活动规则">
          <rule-card v-for="(item, index) in form.regulationVosJson" :key="index" :data="item" :index="index" :activeType="activeType">
            <div class="edit-rules">
              <el-button @click="edit(item, index)">编辑</el-button>
              <el-button @click="copy(item, index)" :disabled="form.regulationVosJson.length >= 6">复制</el-button>
              <el-button @click="deleteRule(index)">删除</el-button>
            </div>
          </rule-card>
          <div class="add-form" @click="popForm(true)" v-if="form.regulationVosJson.length < 6">
            <i class="el-icon-plus"></i> 添加规则
          </div>
        </el-form-item>

        <el-form-item label="选择审核管理员" prop="admin" v-if="!isAdmin">
          <el-select v-model="form.admin" placeholder="请选择管理员" style="width: 224px">
            <el-option v-for="item in adminNameList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="btn-groups bottom">
      <div>
        <el-checkbox v-model="haveRead">我已知悉并认同</el-checkbox>
        <span class="protal" @click="openToggleProtocol">{{ `《${activeType === 7 ? '天天特价活动协议' : '限时秒杀活动协议'}》` }}</span>
      </div>
      <div>
        <el-button @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="next" v-loading="loading">下一步</el-button>
      </div>
    </div>

    <el-dialog
      title="填写活动规则"
      :visible.sync="dialogVisible"
      :center="true"
      top="5%"
      width="60%"
      @close="closeDialogVisible">
      <addForm v-if="dialogVisible" :activeType="activeType" :oilNoList="oilNoList" :wallConfig="wallConfig" @addRule="addRule" @cancel="popForm(false)" ref="formData" />
    </el-dialog>

    <el-dialog
      :title="`${activeType === 7 ? '天天特价活动协议' : '限时秒杀活动协议'}`"
      :visible.sync="toggleProtocol"
      :center="true"
      top="5%"
      width="600px">
      <div v-html="getXssIntro(protocolContent)"></div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import addForm from './form.vue'
import ruleCard from './ruleCard.vue'
import { gasDetail, getWallConfig, oilConfig, getProtocol, addReadRead } from '@/api/marketPromotion/signUpActive'
import { getXssIntro } from '@/utils/xss'

export default {
  name: 'daySpecial-first',
  props: ['activeType'],
  components: {
    addForm,
    ruleCard
  },
  data () {
    const _this = this
    return {
      form: {
        gasName: '',
        isFundUsed: 1,
        activityType: _this.activeType,
        admin: null,
        regulationVosJson: [],
        isRebate: _this.activeType === 9 ? 1 : null
      },
      rules: {
        admin: [{ required: true, message: '请选择审核管理员', trigger: 'change' }]
      },
      dialogVisible: false,
      isHasFundsAccount: 0, // 是否含有基金账户
      frostBalance: 0, // 冻结余额
      adminNameList: [], // 管理员名称
      isAdmin: 0, // 是否为管理员
      oilNoList: [], // 活动油号及油价
      wallConfig: {}, // 让利及置顶范围
      whetherEdit: false,
      editIndex: 0,
      loading: false,
      haveRead: false,
      toggleProtocol: false,
      protocolContent: ''
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    getXssIntro,
    popForm (boolean) {
      this.dialogVisible = boolean
    },
    addRule (form) {
      if (this.whetherEdit) {
        this.form.regulationVosJson.splice(this.editIndex, 1, form)
        this.whetherEdit = false
      } else {
        this.form.regulationVosJson.push(form)
      }
      this.dialogVisible = false
    },
    edit (item, index) {
      this.dialogVisible = true
      this.editIndex  = index
      this.whetherEdit = true
      let params
      if (this.activeType === 9) {
        params = {
          activeTimes: item.activeTimes.map(val => {
            return [
              val[0].slice(0,5),
              val[1].slice(0,5)
            ]
          })
        }
      } else {
        params = {}
      }
      this.$nextTick(() => {
        this.$refs.formData.form = Object.assign({}, {
          ...item,
          ...params
        })
        this.$refs.formData.changeActiveTime(true)
      })
    },
    copy (item) {
      this.dialogVisible = true
      let params
      if (this.activeType === 9) {
        params = {
          activeTimes: item.activeTimes.map(val => {
            return [
              val[0].slice(0,5),
              val[1].slice(0,5)
            ]
          })
        }
      } else {
        params = {}
      }
      this.$nextTick(() => {
        this.$refs.formData.form = Object.assign({}, {
          ...item,
          ...params
        })
        this.$refs.formData.changeActiveTime(true)
      })
    },
    deleteRule (index) {
      this.form.regulationVosJson.splice(index, 1)
    },
    next () {
      if (!this.form.regulationVosJson.length) {
        this.$message.warning('请添加活动规则')
        return
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (!this.haveRead) return this.$message.error(`请勾选${this.activeType === 7 ? '天天特价活动协议' : '限时秒杀活动协议'}`)
          // 调用阅读记录接口
          await addReadRead({ protocolType: this.activeType === 7 ? 'dailySpecial' : 'secKill' })

          this.loading = true
          let regulationVosJson = JSON.parse(JSON.stringify(this.form.regulationVosJson))
          regulationVosJson.map(item => item.activeTimes = item.activeTimes.map(val => `${val[0]}-${val[1]}`).join(','))
          let data = Object.assign({}, this.form, {
            gasName: this.userInfo.gasName,
            regulationVosJson: JSON.stringify(regulationVosJson),
          })
          this.$emit('submit', data)
        }
      })
    },
    // 获取油站信息
    async getGasDetail () {
      try {
        const { code, result } = await gasDetail()
        if (code !== 200) return
        this.isHasFundsAccount = result.isHasFundsAccount
        this.form.isFundUsed = this.isHasFundsAccount ? 1 : null
        this.frostBalance = result.frostBalance
        this.adminNameList = result.adminUserSelect
        this.isAdmin = result.isAdmin
      } catch (error) {
        console.log(error)
      }
    },
    // 获取置顶范围
    async queryWallConfig () {
      try {
        const { code, result } = await getWallConfig()
        if (code !== 200) return
        this.wallConfig = result.filter(item => item.activityType === this.activeType)
      } catch (error) {
        console.log(error)
      }
    },
    // 获取油号及油价
    async getOilDetail () {
      try {
        const { code, result } = await oilConfig()
        if (code !== 200) return
        this.oilNoList = result
      } catch (error) {
        console.log(error)
      }
    },
    // 查看协议
    openToggleProtocol () {
      this.getProtocol()
      this.toggleProtocol = true
    },
    async getProtocol () {
      try {
        const {code, result} = await getProtocol({ protocolType: this.activeType === 7 ? 'dailySpecial' : 'secKill' })
        if (code !== 200) return
        this.protocolContent = decodeURIComponent(result.protocolContent)
        this.haveRead = result.haveRead
      } catch (error) {
        console.log(error)
      }
    },
    closeDialogVisible () {
      this.$track.clickEvent('天天特价-添加规则', 1632832580, { tysj_trade_type: 2 })
    }
  },
  created () {
    this.getGasDetail()
    this.queryWallConfig()
    this.getOilDetail()
    this.getProtocol()
  }
}
</script>
<style lang="less" scoped>
  @import url('./first.less');
</style>
